module.exports = __webpack_public_path__ + "static/media/instapage8.5568ea6c.png";